/* ============================================================
   COVVA · SYNCHRO PANIER — pack machine + pochette + cadeau mystère
   Garantit : quantité de CHAQUE ligne offerte (properties._free_gift ===
   'covva_machine' : pochette et cadeau mystère) == quantité totale des
   lignes machine (handle 'covva-cup') dans le panier. Plus aucune
   machine = lignes offertes retirées (quantité 0). Couvre l'ajout direct (déclenché par
   covva-pdp.js) ET les modifications manuelles (tiroir panier ou page
   /cart), en écoutant les 3 événements pertinents déjà utilisés par ce
   thème :
     - cart:item-added (assets/product.js, assets/app.js, covva-pdp.js —
       nécessaire même quand la ligne pochette existe déjà : initPouchAutoAdd()
       ne dispatche cart:refresh QUE quand elle crée la ligne, pas quand
       elle existe déjà, donc un 2e ajout machine ne serait sinon jamais
       réconcilié tant qu'aucun autre événement ne survient)
     - cart:refresh (assets/cart.js, assets/app.js, covva-pdp.js)
     - line-item:change:end (assets/cart.js, assets/app.js — dispatché
       après un changement manuel de quantité ou une suppression de ligne)
   Un appel initial au chargement sert de filet de rattrapage (panier
   désynchronisé par un échec réseau précédent, onglet fermé pendant une
   synchro, etc.) : sans lui, un écart ne se corrige que sur le prochain
   événement, jamais tout seul à l'ouverture du panier.
   Idempotent : guard window.__covvaPackSyncInit
   ============================================================ */
(function () {
  if (window.__covvaPackSyncInit) return;
  window.__covvaPackSyncInit = true;

  var MACHINE_HANDLE = 'covva-cup';
  var updateUrl = ((window.theme && theme.routes && theme.routes.cart_update_url) || '/cart/update').replace(/\.js$/, '') + '.js';
  var syncing = false;

  function reconcile() {
    if (syncing) return;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;

        var machineQty = 0;
        cart.items.forEach(function (it) {
          if (it.handle === MACHINE_HANDLE) machineQty += it.quantity;
        });

        // Regroupe les lignes offertes par variante : une remise auto peut
        // scinder une même pochette en 2 lignes (1 offerte + 1 au prix fort,
        // ex. Duo 2 couleurs puis retrait d'une machine). Si le total d'une
        // variante diffère du nombre de machines, on garde la 1re ligne à la
        // bonne quantité et on met les autres à 0. Tout part dans la même
        // requête (mise à jour par clé de ligne).
        var groups = {};
        cart.items.forEach(function (it) {
          if (!(it.properties && it.properties._free_gift === 'covva_machine')) return;
          var g = groups[it.variant_id] || (groups[it.variant_id] = { total: 0, keys: [] });
          g.total += it.quantity;
          g.keys.push(it.key);
        });

        var updates = {};
        var needsUpdate = false;
        Object.keys(groups).forEach(function (vid) {
          var g = groups[vid];
          if (g.total === machineQty) return;
          g.keys.forEach(function (key, i) { updates[key] = i === 0 ? machineQty : 0; });
          needsUpdate = true;
        });

        if (!needsUpdate) return;

        syncing = true;
        fetch(updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) {
            syncing = false;
            if (r && r.ok) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
          })
          .catch(function () { syncing = false; });
      })
      .catch(function () { /* silent */ });
  }

  document.addEventListener('cart:item-added', reconcile);
  document.addEventListener('cart:refresh', reconcile);
  document.addEventListener('line-item:change:end', reconcile);

  reconcile();
})();
